import { TNavigationEntry } from '@internal/utils/navigation/TNavigationEntry';

export const getNavigationItemLabel = (entry?: TNavigationEntry): string => {
    if (!entry) {
        return '';
    }
    return entry.text || entry.name;
};
